module.exports = __webpack_public_path__ + "img/header-memoireRingsHalfSetMemories.bb99341.jpg";